if (!customElements.get('gift-points')) {
  customElements.define('gift-points', class GiftPoints extends HTMLElement {

    variantIdChangedUnsubscriber = undefined;
    constructor() {
      super();
      this.data = window.gift_points_data || {};
      this.currencySymbol = window.active_currency_symbol;
      this.currencyRate = Shopify.currency.rate;
      this.staticTextEl = this.querySelector(".static-text");
      this.dynamicTextEl = this.querySelector(".dynamic-text");
      this.spanEl = this.querySelector(".dynamic-text span");
    }
    connectedCallback() {
      this.initGiftPoints();
      this.variantIdChangedUnsubscriber = subscribe(
        PUB_SUB_EVENTS.variantChange,
        this.handleGiftPoints.bind(this)
      );
    }
    disconnectedCallback() {
      if (this.variantIdChangedUnsubscriber) {
        this.variantIdChangedUnsubscriber();
      }
    }

    // 计算gift金额 并控制gift points版块是否显示
    _calculateGiftPoints(variantPrice, variantComparePrice) {
      let actualDiscount = this.data.discount;  // 获取产品折扣
      let discountPrice = variantPrice;

      if (actualDiscount && actualDiscount.indexOf('%') > -1) {
        let activityDiscount = parseFloat(actualDiscount.replace("%", "")) / 100;
        discountPrice = +(variantPrice * (1 - activityDiscount)).toFixed(2);
      } else if (actualDiscount) {
        let activityDiscount = actualDiscount * this.currencyRate * 100;
        discountPrice = variantPrice - activityDiscount;
      }

      let comparePriceLow = variantComparePrice * 0.75;
      // 增加一层判断: 针对govx: compare_at_price * 0.75 与 折扣优惠价, 取小值
      let toComparePrice = Math.min(discountPrice, comparePriceLow);

      let { priceToShow, giftPriceLimit, giftPrice } = this.data;
      let totalGiftPrice = 0;

      if (priceToShow <= toComparePrice) {
        totalGiftPrice = Math.floor(toComparePrice / priceToShow) * giftPrice;
        if (giftPriceLimit && totalGiftPrice > giftPriceLimit) {
          totalGiftPrice = giftPriceLimit;
        }
        this.staticTextEl?.classList.add("hidden");
        this.dynamicTextEl?.classList.remove("hidden");
        if(this.spanEl) {
          this.spanEl.textContent = `${this.currencySymbol}${Number(totalGiftPrice.toFixed(1))}`;
        }
      } else {
        this.staticTextEl?.classList.remove("hidden");
        this.dynamicTextEl?.classList.add("hidden");
      }
    }


    initGiftPoints() {
      let variantPrice = this.data.targetPrice;
      let variantComparePrice = this.data.targetComparePrice || variantPrice;
      this._calculateGiftPoints(variantPrice, variantComparePrice);
    }

    // 订阅事件：变体切换
    handleGiftPoints(event) {
      let variant = event.data.variant;
      let variantPrice = variant.price;
      let variantComparePrice = variant.compare_at_price || variantPrice;
      this._calculateGiftPoints(variantPrice, variantComparePrice);
    }
  });
}